module.exports = __webpack_public_path__ + "static/media/skull-new-2.d8cd6939.png";